import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes, { customPagePropType } from '../helpers/propTypes';
import usePageAria from '../hooks/usePageAria';
import { userMetrics } from '../userMetrics';
import Md from './Md';
import { MainHeading, NormalText, SubtleText } from './typography';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  closeText: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin: `0 ${theme.spacing(1)}px`,

    '& > *': {
      margin: `${theme.spacing(1)}px 0`,
    },
  },

  closeButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),

    '& > *': {
      margin: `0 ${theme.spacing(1)}px`,
    },
  },
}));

function ClosePrompt({ onCancel, onClose, customPage }) {
  const aria = usePageAria();
  const classes = useStyles();

  return (
    <div className={classes.content} {...aria}>
      <div className={classes.closeText}>
        <MainHeading variant="h1">
          {customPage.title || (
            <FormattedMessage
              defaultMessage="Are you sure you want to leave?"
              id="Modal.closePrompt"
            />
          )}
        </MainHeading>
        <NormalText>
          {customPage.text ? (
            <Md tags={customPage.tags}>{customPage.text}</Md>
          ) : (
            <FormattedMessage
              defaultMessage="Any information you have entered will not be saved."
              id="Modal.closeDescription"
            />
          )}
        </NormalText>
        {customPage.subText && (
          <SubtleText variant="subtitle1">
            <Md tags={customPage.tags}>{customPage.subText}</Md>
          </SubtleText>
        )}
      </div>
      <div className={classes.closeButtons}>
        <Button
          onClick={() => {
            userMetrics.track('Leave button pressed');
            onClose(customPage.buttonAction);
          }}
        >
          {customPage.buttonText || (
            <FormattedMessage defaultMessage="Leave" id="Modal.closeButton" />
          )}
        </Button>
        <Button color="primary" onClick={onCancel} variant="contained">
          <FormattedMessage defaultMessage="Go back" id="Modal.closeCancel" />
        </Button>
      </div>
    </div>
  );
}

ClosePrompt.propTypes = {
  customPage: customPagePropType,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

ClosePrompt.defaultProps = {
  customPage: {},
};

export default ClosePrompt;
